import { render, staticRenderFns } from "./EditPostPurchaseContent.vue?vue&type=template&id=49401950&scoped=true&"
import script from "./EditPostPurchaseContent.vue?vue&type=script&lang=js&"
export * from "./EditPostPurchaseContent.vue?vue&type=script&lang=js&"
import style0 from "./EditPostPurchaseContent.vue?vue&type=style&index=0&id=49401950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49401950",
  null
  
)

export default component.exports